import React from 'react'
import _ from 'underscore'
import { ChevronDown } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import Currency from '../../currency'
import PaymentTerm from './payment_term'

class CombineOrders extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      selected_orders: [],
      open: false
    }
  }

  onOpenChange = (open) => {
    this.setState({open})
  }

  onOrderChecked = (order_id) => {
    if (this.state.selected_orders.includes(order_id)) {
      this.setState(prevState => ({
        selected_orders: prevState.selected_orders.filter(id => id !== order_id)
      }))
    } else {
      this.setState(prevState => ({
        selected_orders: [...prevState.selected_orders, order_id]
      }))
    }
  }

  onCancel = () => {
    this.setState({selected_orders: [], open: false})
  }

  onCombine = () => {
    this.props.onCombineOrders(this.state.selected_orders)
    this.setState({selected_orders: [], open: false})
  }

  render() {
    return (
      <Popover open={this.state.open} onOpenChange={this.onOpenChange}>
        <PopoverTrigger asChild>
          <Button variant="outline" size="sm">
            Combine Orders <ChevronDown className="size-4"/>
          </Button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-[640px] max-w-[calc(100vw-2rem)]">
          {this.props.orders.length > 1 ?
            <div>
              {_.map(this.props.orders, (order) => {
                const isChecked = this.state.selected_orders.includes(order.id)

                return (
                  <div
                    key={order.id}
                    className={cn(
                      'grid grid-cols-12 items-center gap-2 rounded-md p-2 mb-2 cursor-pointer',
                      isChecked ? 'bg-primary/5 text-primary' : 'hover:bg-muted/50'
                    )}
                    onClick={() => this.onOrderChecked(order.id)}
                  >
                    <div className="col-span-2 flex items-center">
                      <input className="mr-2" type="checkbox" checked={isChecked} readOnly/>
                      <label className="mb-0">
                        {"Order " + order.id}
                      </label>
                    </div>
                    <div className="col-span-5 break-words">{order.description}</div>
                    <div className="col-span-2">
                      {order.paid ?
                        <Badge variant="success" className="font-bold">Paid</Badge>
                        : <Badge variant="secondary" className="font-bold">Unpaid</Badge>
                      }
                    </div>
                    <div className="col-span-3 flex flex-col items-end">
                      <PaymentTerm payment_term={order.payment_term}/>
                      <Currency value={order.total} currency={order.currency_code} placeholder='-' />
                    </div>
                  </div>
                  )
                })}
              <div className="flex justify-end gap-2">
                <Button variant="success" size="sm" onClick={this.onCombine}>Combine</Button>
                <Button variant="destructive" size="sm" onClick={this.onCancel}>Cancel</Button>
              </div>
            </div>
            :
            <div className="flex items-center justify-center text-center">
              <Badge variant="warning" size="md">No Orders to Combine</Badge>
            </div>
          }
        </PopoverContent>
      </Popover>
    )
  }

}

export default CombineOrders
